import { httpsCallable } from 'firebase/functions'
import { functions } from '../config/firebase'

export type CreateAuthUserPayload = { email: string; password: string; username: string; role?: 'client' | 'admin' }
export type UpdateAuthUserPayload = { uid: string; email?: string; password?: string; username?: string; role?: 'client' | 'admin' }
export type DeleteAuthUserPayload = { uid: string }

class AdminFunctionsService {
  async createAuthUser(payload: CreateAuthUserPayload): Promise<{ uid: string }> {
    const callable = httpsCallable(functions, 'createAuthUser')
    const res = await callable(payload)
    return res.data as any
  }

  async updateAuthUser(payload: UpdateAuthUserPayload): Promise<void> {
    const callable = httpsCallable(functions, 'updateAuthUser')
    await callable(payload)
  }

  async deleteAuthUser(payload: DeleteAuthUserPayload): Promise<void> {
    const callable = httpsCallable(functions, 'deleteAuthUser')
    await callable(payload)
  }
}

export default new AdminFunctionsService()
